import { useNavigate } from "react-router";

import { getImageUrl } from "simplydo/core/images";

import BaseChip, { type ChipConfiguration } from "./BaseChip";

type ProfileChipProps = ChipConfiguration & {
  forType: "profile" | "organisation";
  profile: { _id: string; name?: string; overview?: string } | undefined;
};

const ProfileChip = ({
  profile,
  forType = "profile",
  ...props
}: ProfileChipProps) => {
  const navigate = useNavigate();

  const imageUrl = getImageUrl(
    profile,
    ["logo", "darkLogo"],
    ["200x200", "SCALEx200"],
    "images/defaults/profile-logo.png",
  );

  return (
    <BaseChip
      {...props}
      style={{ maxWidth: 200 }}
      onClick={
        props.disabled
          ? undefined
          : (e) => {
              if (props.onClick) {
                props.onClick(e);
              } else {
                if (forType === "profile") {
                  navigate(`/profiles/${profile?._id}`);
                }
              }
            }
      }
      title={profile?.name || "Unknown profile"}
      subtitle={profile?.overview || ""}
      imageUrl={imageUrl}
      avatarBackgroundSize={forType === "organisation" ? "contain" : "cover"}
    />
  );
};

export default ProfileChip;
